module.exports = __webpack_public_path__ + "img/logo.86a1e725.png";